"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StorageClient = /** @class */ (function () {
    function StorageClient(frame) {
        this.frame = frame;
    }
    StorageClient.prototype.clear = function () {
        return Promise.resolve(this.frame.clear());
    };
    StorageClient.prototype.getItem = function (key) {
        var _this = this;
        return new Promise(function (resolve) {
            var callback = function (msg) {
                var payload = msg.data || {};
                if (payload.key === key) {
                    window.removeEventListener('message', callback);
                    resolve(payload.data);
                }
            };
            window.addEventListener('message', callback);
            _this.frame.get(key);
        });
    };
    StorageClient.prototype.setItem = function (key, data) {
        return Promise.resolve(this.frame.set(key, data));
    };
    StorageClient.prototype.removeItem = function (key) {
        Promise.resolve(this.frame.remove(key));
    };
    return StorageClient;
}());
exports.default = StorageClient;
